import * as TogglePrimitive from "@radix-ui/react-toggle";
import styled, { css as styledCSS } from "styled-components";

export const Layout = styled(TogglePrimitive.Root)<{ $toggleType: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: var(
    --toggle-button-border-radius,
    var(--button-2px-border-radius, var(--2px))
  );
  padding: var(--toggle-button-padding, var(--button-4px-padding, var(--4px)));

  outline: none;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  font-family:
    Open Sans,
    sans-serif;
  &:focus {
    border: 1px solid var(--mode-border-primary-strong);
    box-shadow:
      0px 0px 2px var(--mode-vector-primary-default),
      inset 0 0 2px var(--mode-vector-primary-default);
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ $toggleType }) =>
    $toggleType === "icon" &&
    styledCSS`
    width: 32px;
    height: 32px;
      svg {
        min-width: 24px;
        min-height: 24px;
      }
      svg path {
        fill: var(--mode-vector-neutral-strong);
      }

      &:hover, &[aria-pressed="true"] {
        background-color: var(--mode-bg-neutral-weakest);
        box-shadow: 0px 1px 4px
        var(--mode-shadow-default);
        svg path {
            fill: var(--mode-vector-primary-default);

        }
      }

      &:focus {
        border: 1px solid var(--mode-border-primary-strong);
        box-shadow: 0px 0px 2px
            var(--mode-vector-primary-default),
          inset 0 0 2px var(--mode-vector-primary-default);
      }

      &:disabled {
        svg path {
          fill: var(--mode-vector-neutral-weakest);
        }
      }
  `}

  ${({ $toggleType }) =>
    $toggleType === "text" &&
    styledCSS`
    width: 42px;
    height: 24px;
    color: var(--mode-text-neutral-weakest);
    border: 1px solid transparent;

      &[aria-pressed="true"]:hover:not([disabled]) {
        background-color: var(--mode-bg-neutral-weakest);
        color: var(--mode-text-neutral-weakest);
      }

      &[aria-pressed="false"]:hover:not([disabled]), &[aria-pressed="true"] {
        color: var(--mode-text-primary-default);
        background-color: var(--mode-bg-primary-weakest);
      }

      &[aria-pressed="true"]:focus {
        background-color: var(--mode-bg-primary-strong);
        color: var(--mode-text-neutral-inverse);
      }

      &:disabled {
        color: var(--mode-text-neutral-inverse-weak);
        background-color: var(--mode-bg-neutral-weakest);
      }

      &:active {
        background-color: var(--mode-bg-primary-strong);
        color: var(--mode-text-neutral-inverse);
      }
  `}
`;
